import React, { FC } from 'react'

import { useNotify, useRecordContext, useRedirect, useRefresh, useStore } from 'react-admin'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
// import { QuickFilter } from 'dash/shared';
// import { useLazyQuery } from '@apollo/client';

import { AasmTransitionActionDropdown } from 'dash/shared'
import {
  Account,
  // User
} from 'shared/types'
import {
  // FETCH_CURRENT_USER,
  FIRE_AASM_TRANSITION,
} from 'shared/gql'
import { Membership } from 'shared/types'
import AppState from 'shared/app_state'

// const MembershipFilter = (props) => (
//   <Filter {...props}>
//     <SearchInput source="q" alwaysOn />
//     {/* <QuickFilter source="status" label="Customers" defaultValue={'active'} /> */}
//     {/* <QuickFilter source="status" label="Churned Customers" defaultValue={'churned'} /> */}
//   </Filter>
// );

type MembershipListActionsProps = {
  account: Account
  record?: Membership
  source: string
}

export const MembershipListActions: FC<MembershipListActionsProps> = ({ account }) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const redirect = useRedirect()
  const record = useRecordContext()
  const [accountId, setAccountId] = useStore('accountId', null)

  // const updateCurrentAccount = ({ currentUser }: { currentUser: User }): void => {
  //   console.log('currentUser', currentUser);
  //   const activeMembership = currentUser.memberships.find((m) => m.status == 'active');
  //   AppState.setCurrentAccount(activeMembership != null ? activeMembership.account : null);
  //   refresh();
  // };

  // const [fetchCurrentUser] = useLazyQuery(FETCH_CURRENT_USER, {
  //   onCompleted: updateCurrentAccount,
  // });

  // const fetchCurrentUserAndUpdateCurrentAccount = (): void => {
  //   // TODO this is broken and not working as expected
  //   // lazy query does not appear to actually be firing off a request
  //   console.log('fetchingCurrentUser');
  //   fetchCurrentUser();
  // };

  const onMembershipStatusTransitionSuccess = async ({
    updateMembership: membership,
  }: {
    updateMembership: Membership
  }) => {
    const { account } = membership
    switch (membership.status) {
      case 'active':
        await AppState.updateCurrentAccount({ id: account.id })
        redirect(`/account/${account.id}/services/form`)
        setAccountId(account.id)
        break
      case 'declined':
        // This is only for denying an invitation. We are guaranteed the user
        // has at least one other active membership
        refresh()
        break
      case 'inactive':
        // TODO handle the deactivate case

        // if (account.id == membership.account.id) fetchCurrentUserAndUpdateCurrentAccount();
        break
    }
  }

  const renderMembershipStatusActionOption = (event: string) => {
    switch (event) {
      case 'accept_invitation':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircleIcon fontSize="small" htmlColor="green" />
            <span style={{ marginLeft: 5 }}>Accept</span>
          </div>
        )
      case 'decline_invitation':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <HighlightOffIcon fontSize="small" htmlColor="red" />
            <span style={{ marginLeft: 5 }}>Decline</span>
          </div>
        )
      case 'inactive':
        return <div>{event.split('_').join(' ')}</div>
    }
  }

  const onError = (e) => notify(`${e}`, { type: 'error' })

  if (!record) return null

  const events = record.availableAasmEvents

  if (events.length == 0) return null

  return (
    <AasmTransitionActionDropdown
      events={events}
      gql={FIRE_AASM_TRANSITION}
      resourceID={record.id}
      onCompleted={onMembershipStatusTransitionSuccess}
      onError={onError}
      renderOption={renderMembershipStatusActionOption}
    />
  )
}
